import type { ProviderDriverKind } from "@afar-research/contracts";

/** Experimental Agent Providers require an explicit user selection. */
export function canAutomaticallySelectProvider(driver: ProviderDriverKind): boolean {
  return driver === "codex";
}
